import {captureException, captureMessage, withScope} from '@sentry/browser';
import {IErrorDescription} from './errors';
import {AdditionalParams} from './logging';

export function logErrorToSentry(errorDescription: IErrorDescription, {reason, ...extra}: AdditionalParams) {
  withScope((scope) => {
    scope.setExtras(extra);

    scope.setTags({
      biId: String(errorDescription.id),
      biName: errorDescription.name,
    });

    if (reason) {
      if (typeof reason === 'string') {
        captureMessage(reason);
      } else {
        captureException(reason);
        try {
          scope.setExtra('stringified', JSON.stringify(reason || '---').slice(0, 100));
        } catch (e) {
          captureException(e);
          console.error(e);
        }
      }
    } else {
      captureMessage(errorDescription.name);
    }
  });
}
